import Social from '../../services/API/Social';
import { useQueryClient, useMutation } from "react-query";
import LikeIcon from '@mui/icons-material/ThumbUpTwoTone';
import HelpfulIcon from '@mui/icons-material/LightbulbTwoTone';
import DiscordIcon from '@mui/icons-material/ErrorTwoTone';
import { txt } from "../../services/translation";

export default function Reactions({post, form, onClose, queryKey, page}){

    const queryClient = useQueryClient();

    /** Ajout optimiste de la réaction */
    const addReaction = useMutation({

        mutationFn: reaction => Social.postReaction(reaction),

        onMutate: async reaction => {

            await queryClient.cancelQueries({ queryKey: queryKey })

            const previous = queryClient.getQueryData(queryKey)

            queryClient.setQueryData(queryKey, old => {

                const idx = old.pages[page - 1].data.findIndex(p => p.id === post.id);

                let newPost = {...post};
                newPost.reactionsSum.total++;
                newPost.reactionsSum[reaction.class]++;
                newPost.myReaction = reaction.class;

                let copy = {...old};
                copy.pages[page - 1].data[idx] = newPost;

                return copy;
            })

            return { previous }
        },

        onError: (e, data, context) => {
            console.log(e, data)
            queryClient.setQueryData(queryKey, context.previous)
        },

        onSettled: () => {
            queryClient.invalidateQueries({ queryKey: queryKey })
        },
    })


    const handleClick = value => {

        const reaction = {class: value, post: post};

        addReaction.mutate(reaction);

        return setTimeout(() => onClose(), 100);
    }

    const like = getReaction('like');
    const helpful = getReaction('helpful');
    const discord = getReaction('discord');

    return <div>

        <div className='social-post-reactions'>

            {post.reactionsSum.like > 0 && like.icon}
            {post.reactionsSum.helpful > 0 && helpful.icon}
            {post.reactionsSum.discord > 0 && discord.icon}

            <span className='social-post-reactions-text'>{post.reactionsSum.total || ''}</span>
        </div>


        {form && 
        
            <div className='social-post-reactions-form-container'>
                <div className='social-post-reactions-form'>

                    <div className='social-post-reactions-option' onClick={() => handleClick('like')}>
                        {like.icon}
                        <span>{like.title}</span>
                    </div>

                    <div className='social-post-reactions-option' onClick={() => handleClick('helpful')}>
                        {helpful.icon}
                        <span>{helpful.title}</span>
                    </div>

                    <div className='social-post-reactions-option' onClick={() => handleClick('discord')}>
                        {discord.icon}
                        <span>{discord.title}</span>
                    </div>

                </div>
            </div>
        }

    </div> 


}


export function getReaction(type){

    const types = {
        like: {class: 'like', title: txt('likeTitle'), icon: <LikeIcon size='small' color='primary'/>},
        helpful: {class: 'helpful', title: txt('helpfulTitle'), icon: <HelpfulIcon size='small' color='success'/>},
        discord: {class: 'discord', title: txt('discordTitle'), icon: <DiscordIcon size='small' color='warning'/>}
    };

    return types[type];
}